import { render, staticRenderFns } from "./DynamicMenu.vue?vue&type=template&id=c2b20d76&scoped=true"
import script from "./DynamicMenu.vue?vue&type=script&lang=js"
export * from "./DynamicMenu.vue?vue&type=script&lang=js"
import style0 from "./DynamicMenu.vue?vue&type=style&index=0&id=c2b20d76&prod&scoped=true&lang=css"
import style1 from "./DynamicMenu.vue?vue&type=style&index=1&id=c2b20d76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b20d76",
  null
  
)

export default component.exports